import React, { useState, useCallback, useEffect, useRef, useMemo } from 'react';
import {
    Table, Input, Button, notification, Space, Modal, Select, Tag, Row, Col,
    Typography, Tooltip,
    Popconfirm, Spin
} from 'antd';
import Highlighter from 'react-highlight-words';
import { SearchOutlined, ExclamationCircleOutlined, UserDeleteOutlined, UserAddOutlined, UsergroupDeleteOutlined, DeleteOutlined, FilePdfOutlined } from '@ant-design/icons';
import { useReactToPrint } from 'react-to-print';
import Icon from '@ant-design/icons';
import locale from 'antd/es/locale/pt_BR';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import { useSelector } from 'react-redux';
import './style.css';
import {
    urlContrato,
    urlContratoAtivos, urlContratoInativos, urlContratoUsuariosVinculados, urlContratosUsuarioControlador
} from '../../services/request/urls';
import axios from 'axios';
import { getToken } from './../../services/token';
import { convertDataUSParaBR } from './../../services/Conversores';

import {
    removeAcento
} from './../../utils/RemoveAcentos';

import { FaSearch, FaUserTimes, FaUsers } from 'react-icons/fa';
import { BiLayerPlus } from 'react-icons/bi';

import { stateGlobal } from '../../interfaces/Global';
import { validacaoPermissaoPorCargo } from '../../services/VerificaSePodeAcessar/verificacaoporCargo';
import { mask, unMask } from '../../utils/MascaraDeCampos';
import { useListagemContrato } from './useListagemContrato';
import { styledRelatorioContrato } from './styleRelatorioContrato';
import TableWrapperPrint from './components/TableWrapperPrint';

const { Text, Title } = Typography;
const NAME_LS_STORAGE_FILTERS = '@GovFacil:FiltrosContrato'
const NAME_LS_STORAGE_SORTERS = '@GovFacil:SortersContrato'

interface interfDadosTabela {
    id: number;
    uuid: string;
    nome: string;
    status: boolean;
    envio_proposta: string;
    vigencia: string | number | null | Date | boolean | any;
    valor_contratado: string;
    cadastro_processos: string;
    observacao: string;
    created_at: string;
    updated_at: string;
    modalidade: {
        id: number;
        nome: string;
    },
    esfera: {
        id: number;
        nome: string;
    },
    poder: {
        id: number;
        nome: string;
    },
    plano: {
        id: number;
        nome: string;
    },
    situacao_contrato: {
        id: number;
        nome: string;
    },
    tipo_contrato: {
        id: number;
        nome: string;
    },
    controladorContrato: [
        {
            id: number | null;
            contratoId: number | null;
            cidadeId: number | null;
            estadoId: number | null;
            usuarioId: number | null;
            permissaoNotificacaoId: number | null;
        }
    ]
}

interface dadosUsuariosTabelaModal {
    id: number,
    nome: string,
    status_vinculo: boolean
}

const IconSerach = (props: any) => <Icon {...props} component={FaSearch} ></Icon>
const IconDesvincularUser = (props: any) => <Icon {...props} component={FaUserTimes} ></Icon>
const IconUsuarios = (props: any) => <Icon {...props} component={FaUsers} ></Icon>
const IconBiLayerPlus = (props: any) => <Icon {...props} component={BiLayerPlus} ></Icon>

const ListagemContrato: React.FC = () => {

    const history = useHistory();
    const propsState = useSelector((state: stateGlobal) => state.global);

    const refIdContratoSelecionado = useRef<number | null>(null);
    const refDadosUsuarioModal = useRef<any>(null);

    const refContagemDoFiltro = React.useRef<Array<any>>([]);
    const refContagemDoFiltroTabelaModal = React.useRef<Array<any>>([]);

    const {
        loadingPage,
        setLoadingPage,
        refComponentToPrint,
        createStyledRetratoOuPaisagem,
    } = useListagemContrato();

    const handlePrint = useReactToPrint({
        content: () => refComponentToPrint.current,
        onAfterPrint: () => {
            setLoadingPage(false);
            setShowPrintComponent(false);
            try {
                if (createStyledRetratoOuPaisagem.current && createStyledRetratoOuPaisagem.current.parentNode) {
                    document.head.removeChild(createStyledRetratoOuPaisagem.current);
                    createStyledRetratoOuPaisagem.current = null;
                }
            } catch (error) {
                createStyledRetratoOuPaisagem.current = null;
            }
        },
        onBeforePrint: () => { setLoadingPage(true); },
        documentTitle: `Listagem de Contratos ${new Date().toLocaleDateString("pt-BR")}`
    });

    const handleClickPrint = useCallback(() => {
        setShowPrintComponent(true);
        applyPrintOrientation('portrait');
    }, []);

    const applyPrintOrientation = (orientation: 'portrait' | 'landscape') => {
        try {
            if (createStyledRetratoOuPaisagem.current && createStyledRetratoOuPaisagem.current.parentNode) {
                document.head.removeChild(createStyledRetratoOuPaisagem.current);
            }
        } catch (error) {
            // Ignora erro se o elemento já foi removido
        }
        createStyledRetratoOuPaisagem.current = document.createElement('style');
        createStyledRetratoOuPaisagem.current.innerHTML = styledRelatorioContrato(orientation);
        document.head.appendChild(createStyledRetratoOuPaisagem.current);
    };

    //para poder cancelar a requisição
    const signal = axios.CancelToken.source();

    const [selectedRowKeys, setSelectedRowKeys] = useState<Array<string>>([]);
    const [loadingTable, setLoadingTable] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const [dadosTabelaState, setDadosTabelaState] = useState<Array<interfDadosTabela>>([]);
    const [dadosFiltradosParaImpressao, setDadosFiltradosParaImpressao] = useState<Array<interfDadosTabela>>([]);
    const [hasSelectedAdd, setHasSelectedAdd] = useState(true);
    const [hasSelectedView, setHasSelectedView] = useState(false);
    const [hasSelectedEdit, setHasSelectedEdit] = useState(false);
    const [hasSelectedDel, setHasSelectedDel] = useState(false);
    const [showPrintComponent, setShowPrintComponent] = useState(false);

    const refValorSelecioneFiltro = React.useRef<string>('Contratos');
    const [valorSelecione, setValorSelecione] = useState('Contratos');

    const [modalDesvincularUserVisible, setModalDesvincularUserVisible] = useState(false);
    const [loadingTableModal, setLoadingTableModal] = useState(false);
    const [selectedRowKeysModal, setSelectedRowKeysModal] = useState<Array<string>>([]);
    const [searchTextModal, setSearchTextModal] = useState('');
    const [searchedColumnModal, setSearchedColumnModal] = useState('');
    const [dadosTabelaUsuariosModal, setDadosTabelaUsuariosModal] = useState<{
        id: number,
        qtdAtivos: number,
        qtdInativos: number,
        nome: string,
        usuarios: Array<dadosUsuariosTabelaModal>
    }>();

    const [filterTipo_contrato, setFilterTipo_contrato] = useState<{
        nome: Array<string> | null
        poder: Array<string> | null
        plano: Array<string> | null
        tipo_contrato: Array<string> | null
        validade_teste: Array<string> | null
        vendedores: Array<string> | null
        vigencia_atual: Array<string> | null
    }>(() => {

        let dadosLocalStogFiltro: string | null = localStorage.getItem(NAME_LS_STORAGE_FILTERS);
        let localStogFiltro: any = null;
        if (typeof dadosLocalStogFiltro == 'string') {
            localStogFiltro = JSON.parse(dadosLocalStogFiltro);
        }

        if (localStogFiltro) {
            if (localStogFiltro) {
                return localStogFiltro
            } else {
                return []
            }
        } else {
            return []
        }
    });

    const [sortersTableListContrato, setSortersTableListContrato] = useState<{
        field: string | null
        order?: 'ascend' | 'descend'
    }>(() => {

        let dadosLocalStogFiltro: string | null = localStorage.getItem(NAME_LS_STORAGE_SORTERS);
        let localStogFiltro: any = null;
        if (typeof dadosLocalStogFiltro == 'string') {
            localStogFiltro = JSON.parse(dadosLocalStogFiltro);
        }

        if (localStogFiltro) {
            if (localStogFiltro) {
                return localStogFiltro
            } else {
                return null
            }
        } else {
            return null
        }
    });

    useEffect(() => {
        if (showPrintComponent && refComponentToPrint.current) {
            const timer = setTimeout(() => handlePrint(), 100);
            return () => clearTimeout(timer);
        }
    }, [showPrintComponent]);

    //executa apenas ao iniciar o component
    useEffect(() => {
        setLoadingTable(true)
        const buscaDeDados = async () => {
            try {
                let result = await axios.get(urlContratoAtivos,
                    {
                        headers: { 'Authorization': 'Bearer ' + getToken() },
                        cancelToken: signal.token
                    });

                setDadosTabelaState(result.data);
                setDadosFiltradosParaImpressao(result.data);
                setLoadingTable(false)

            } catch (error) {
                let msgErro: any = (error as Error);
                if (msgErro?.message != 'Requisicao cancelada!') {
                    setLoadingTable(false)
                    notification.error({
                        message: 'Erro',
                        description:
                            'Não foi possivel buscar os dados!',
                    });
                }
            }
        }

        buscaDeDados();

    }, []);

    //executa apenas quando desmonta o component
    const comonentExecutaAoDestroy = useEffect(() => () => {
        signal.cancel("Requisicao cancelada!")
    }, []);

    const buscaDadosContratosAtivosAndSetTable = useCallback((): void => {

        setLoadingTable(true)
        const buscaDeDadosContratos = async () => {
            try {
                let result = await axios.get(urlContratoAtivos,
                    {
                        headers: { 'Authorization': 'Bearer ' + getToken() },
                        cancelToken: signal.token
                    });

                setDadosTabelaState(result.data);
                setDadosFiltradosParaImpressao(result.data);
                setLoadingTable(false)

            } catch (error) {
                let msgErro: any = (error as Error);

                if (msgErro?.message != 'Requisicao cancelada!') {
                    setLoadingTable(false)
                    notification.error({
                        message: 'Erro',
                        description:
                            'Não foi possivel buscar os dados!',
                    });
                }
            }
        }

        buscaDeDadosContratos();

    }, []);

    const buscaDadosContratosInativosAndSetTable = useCallback((): void => {

        setLoadingTable(true)
        const buscaDeDadosContratos = async () => {
            try {
                let result = await axios.get(urlContratoInativos,
                    {
                        headers: { 'Authorization': 'Bearer ' + getToken() },
                        cancelToken: signal.token
                    });

                setDadosTabelaState(result.data);
                setDadosFiltradosParaImpressao(result.data);
                setLoadingTable(false)

            } catch (error) {
                let msgErro: any = (error as Error);
                if (msgErro?.message != 'Requisicao cancelada!') {
                    setLoadingTable(false)
                    notification.error({
                        message: 'Erro',
                        description:
                            'Não foi possivel buscar os dados!',
                    });
                }
            }
        }

        buscaDeDadosContratos();

    }, []);

    const handleSearchModal = useCallback((selectedKeys, confirm, dataIndex): void => {
        confirm();
        setSearchTextModal(selectedKeys[0]);
        setSearchedColumnModal(dataIndex);
    }, [searchText]);

    const handleResetModal = useCallback((clearFilters): void => {
        clearFilters();
        setSearchTextModal('');
    }, []);

    //Search da tabela de listagem
    const getColumnSearchPropsModal = useCallback((dataIndex) => {
        let searchInput: any = '';
        return ({
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
                <div style={{ padding: 8 }}>
                    <Input
                        ref={node => {
                            searchInput = node;
                        }}
                        placeholder={`Digite...`}
                        value={selectedKeys[0]}
                        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => handleSearchModal(selectedKeys, confirm, dataIndex)}
                        style={{ width: 188, marginBottom: 8, display: 'block' }}
                    />
                    <Space>
                        <Button
                            type="primary"
                            onClick={() => handleSearchModal(selectedKeys, confirm, dataIndex)}
                            icon={<SearchOutlined />}
                            size="small"
                            style={{ width: 90 }}
                        >
                            Pesquisar
                        </Button>
                        <Button onClick={() => handleResetModal(clearFilters)} size="small" style={{ width: 90 }}>
                            Limpar
                        </Button>
                    </Space>
                </div>
            ),
            filterIcon: (filtered: any) => filtered ? <IconSerach style={{ color: filtered ? '#1890ff' : undefined, fontSize: filtered ? 14 : undefined }} /> : <SearchOutlined />,
            onFilter: (value: any, record: any) =>
                record[dataIndex] ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()) : '',
            onFilterDropdownVisibleChange: (visible: any) => {
                if (visible) {
                    setTimeout(() => searchInput.select());
                }
            },
            render: (text: any) =>
                searchedColumnModal === dataIndex ? (
                    <Highlighter
                        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                        searchWords={[searchText]}
                        autoEscape
                        textToHighlight={text ? text.toString() : ''}
                    />
                ) : (
                    text
                ),
        })
    }, [searchTextModal, searchedColumnModal]);

    const handleSearch = useCallback((selectedKeys, confirm, dataIndex): void => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    }, [searchText]);

    const handleReset = useCallback((clearFilters): void => {
        clearFilters();
        setSearchText('');
    }, []);

    //Search da tabela de listagem
    const getColumnSearchProps = useCallback((dataIndex) => {
        let searchInput: any = '';
        return ({
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
                <div style={{ padding: 8 }}>
                    <Input
                        ref={node => {
                            searchInput = node;
                        }}
                        placeholder={`Digite...`}
                        value={selectedKeys[0]}
                        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        style={{ width: 188, marginBottom: 8, display: 'block' }}
                    />
                    <Space>
                        <Button
                            type="primary"
                            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                            icon={<SearchOutlined />}
                            size="small"
                            style={{ width: 90 }}
                        >
                            Pesquisar
                        </Button>
                        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                            Limpar
                        </Button>
                    </Space>
                </div>
            ),
            filterIcon: (filtered: any) => filtered ? <IconSerach style={{ color: filtered ? '#1890ff' : undefined, fontSize: filtered ? 14 : undefined }} /> : <SearchOutlined />,
            onFilter: (value: any, record: any) => {

                let trecord = removeAcento(record[dataIndex].toString());

                return record[dataIndex] ? trecord.includes(removeAcento(value)) : false

            },
            onFilterDropdownVisibleChange: (visible: any) => {
                if (visible) {
                    setTimeout(() => searchInput.select());
                }
            },
            render: (text: any) =>
                searchedColumn === dataIndex ? (
                    <Highlighter
                        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                        searchWords={[searchText]}
                        autoEscape
                        textToHighlight={text ? text.toString() : ''}
                    />
                ) : (
                    text
                ),
        })
    }, [searchText, searchedColumn]);

    const getColumnSearchProps2 = useCallback((dataIndex) => {
        let searchInput: any = '';
        return ({
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
                <div style={{ padding: 8 }}>
                    <Input
                        ref={node => {
                            searchInput = node;
                        }}
                        placeholder={`Digite...`}
                        value={selectedKeys[0]}
                        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        style={{ width: 188, marginBottom: 8, display: 'block' }}
                    />
                    <Space>
                        <Button
                            type="primary"
                            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                            icon={<SearchOutlined />}
                            size="small"
                            style={{ width: 90 }}
                        >
                            Pesquisar
                        </Button>
                        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                            Limpar
                        </Button>
                    </Space>
                </div>
            ),
            filterIcon: (filtered: any) => filtered ? <IconSerach style={{ color: filtered ? '#1890ff' : undefined, fontSize: filtered ? 14 : undefined }} /> : <SearchOutlined />,
            onFilter: (value: any, record: any) => {
                let trecord = removeAcento(record[dataIndex]?.nome.toString());

                return record[dataIndex]?.nome ? trecord.includes(removeAcento(value)) : false
            },
            onFilterDropdownVisibleChange: (visible: any) => {
                if (visible) {
                    setTimeout(() => searchInput.select());
                }
            },
            render: (text: any) =>
                searchedColumn === dataIndex ? (
                    <Highlighter
                        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                        searchWords={[searchText]}
                        autoEscape
                        textToHighlight={text ? text.toString() : ''}
                    />
                ) : (
                    text
                ),
        })
    }, [searchText, searchedColumn]);

    const getColumnSearchProps2Arr = useCallback((dataIndex) => {
        let searchInput: any = '';
        return ({
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
                <div style={{ padding: 8 }}>
                    <Input
                        ref={node => {
                            searchInput = node;
                        }}
                        placeholder={`Digite...`}
                        value={selectedKeys[0]}
                        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        style={{ width: 188, marginBottom: 8, display: 'block' }}
                    />
                    <Space>
                        <Button
                            type="primary"
                            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                            icon={<SearchOutlined />}
                            size="small"
                            style={{ width: 90 }}
                        >
                            Pesquisar
                        </Button>
                        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                            Limpar
                        </Button>
                    </Space>
                </div>
            ),
            filterIcon: (filtered: any) => filtered ? <IconSerach style={{ color: filtered ? '#1890ff' : undefined, fontSize: filtered ? 14 : undefined }} /> : <SearchOutlined />,
            onFilter: (value: any, record: any) => {

                let trecord = removeAcento(record[dataIndex][0]?.nome.toString());

                return record[dataIndex][0]?.nome ? trecord.includes(removeAcento(value)) : false

            },
            onFilterDropdownVisibleChange: (visible: any) => {
                if (visible) {
                    setTimeout(() => searchInput.select());
                }
            },
            render: (text: any) =>
                searchedColumn === dataIndex ? (
                    <Highlighter
                        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                        searchWords={[searchText]}
                        autoEscape
                        textToHighlight={text ? text.toString() : ''}
                    />
                ) : (
                    text
                ),
        })
    }, [searchText, searchedColumn]);

    const getColumnSearchPropsData = useCallback((dataIndex) => {
        let searchInput: any = '';
        return ({
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => (
                <div style={{ padding: 8 }}>
                    <Input
                        ref={node => {
                            searchInput = node;
                        }}
                        placeholder={`Digite...`}
                        value={selectedKeys[0]}
                        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        style={{ width: 188, marginBottom: 8, display: 'block' }}
                    />
                    <Space>
                        <Button
                            type="primary"
                            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                            icon={<SearchOutlined />}
                            size="small"
                            style={{ width: 90 }}
                        >
                            Pesquisar
                        </Button>
                        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                            Limpar
                        </Button>
                    </Space>
                </div>
            ),
            filterIcon: (filtered: any) => filtered ? <IconSerach style={{ color: filtered ? '#1890ff' : undefined, fontSize: filtered ? 14 : undefined }} /> : <SearchOutlined />,
            onFilter: (value: any, record: any): any => {
                let texto: string | undefined = ''
                if (record[dataIndex]) texto = convertDataUSParaBR(record[dataIndex])

                return (
                    texto ? texto.toString().toLowerCase().includes(value.toLowerCase()) : false
                )
            },
            onFilterDropdownVisibleChange: (visible: any) => {
                if (visible) {
                    setTimeout(() => searchInput.select());
                }
            },
            render: (text: any) =>
                searchedColumn === dataIndex ? (
                    <Highlighter
                        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                        searchWords={[searchText]}
                        autoEscape
                        textToHighlight={text ? text.toString() : ''}
                    />
                ) : (
                    text
                ),
        })
    }, [searchText, searchedColumn]);
    // fim do search da tabela de listagem

    const start = useCallback((): void => {

    }, []);

    //abrir navegar em add contrato
    const clickBotaoAddContrato = useCallback((): void => {

        let dadosLocalStorage: string | null = localStorage.getItem('@GovFacil:contrato');
        let localUserData: any = null;
        if (typeof dadosLocalStorage == 'string') {
            localUserData = JSON.parse(dadosLocalStorage);
        }

        if (localUserData) {
            localStorage.removeItem('@GovFacil:contrato');
        }
        history.push('/contrato/adicionar');

    }, []);

    //abrir navegar em add contrato
    const clickBotaoEditarContrato = useCallback((): void => {

        const buscaDeDados = async () => {

            if (selectedRowKeys.length == 1) {

                setLoadingTableModal(true)
                let objSelecionado: any = {}
                dadosTabelaState.forEach((dados): void => {
                    if (dados.uuid == selectedRowKeys[0]) {
                        objSelecionado = dados
                    }
                })

                try {
                    let resultContratos = await axios.get(urlContrato + '/' + objSelecionado?.id,
                        { headers: { 'Authorization': 'Bearer ' + getToken() } });


                    // let resultVendedores = await axios.get(urlContratoVendedores + '/' + objSelecionado?.id,
                    //     { headers: { 'Authorization': 'Bearer ' + getToken() } });

                    // objSelecionado.vendedores = resultVendedores.data;

                    // let resultEstados = await axios.get(urlContratoEstados + '/' + objSelecionado?.id,
                    //     { headers: { 'Authorization': 'Bearer ' + getToken() } });

                    // objSelecionado.estados = resultEstados.data;
                    // tipo_contrato:


                    // objSelecionado.cidades = resultCidades.data;

                    // const newObjContrato = {
                    //     ...resultContratos.data,
                    //     plano: objSelecionado.plano
                    // }

                    localStorage.setItem('@GovFacil:contrato', JSON.stringify(resultContratos.data));

                    history.push('/contrato/adicionar');
                } catch (error) {

                    let msgErro: any = (error as Error);
                    notification.error({
                        message: 'Erro',
                        description:
                            msgErro?.response?.data?.message ? msgErro?.response?.data?.message : 'Entre em contato com o suporte!',
                    });
                }

            }
        }

        buscaDeDados();

    }, [selectedRowKeys, dadosTabelaState]);

    const onChangeSelectFiltroBuscaTabela = useCallback((e): void => {

        refValorSelecioneFiltro.current = e
        //setando valor do selecione em stado para caso for inativo renderizar outro botao
        setValorSelecione(e);
        switch (e) {
            case 'Inativos':
                buscaDadosContratosInativosAndSetTable();
                break;
            case 'Contratos':
                buscaDadosContratosAtivosAndSetTable();
                break;

            default:
                buscaDadosContratosAtivosAndSetTable();
                break;
        }
    }, []);

    const requestAtivarOuInativarContrato = useCallback((obj): void => {
        setLoadingTable(true);
        const buscaDeDados = async () => {
            // if (selectedRowKeys.length == 1 || selectedRowKeys.length > 1) {
            if (selectedRowKeys.length == 1) {
                let linha: any = [];
                dadosTabelaState.forEach(({ nome, uuid, id }): void => {

                    selectedRowKeys.forEach((val, i) => {
                        if (uuid == val) {
                            linha.push({ id })
                        }
                    });

                })

                try {
                    await axios.patch(urlContrato + "/" + linha[0].id, obj, {
                        //EXEMPLO APENAS PARA EXCLUIR UM [0] ATE CORRIGIR O BACK
                        headers: { 'Authorization': 'Bearer ' + getToken() }
                    })

                    setLoadingTable(false);
                    if (obj.status) {
                        buscaDadosContratosInativosAndSetTable();
                    } else {
                        buscaDadosContratosAtivosAndSetTable();
                    }

                    notification.success({
                        message: 'Sucesso',
                        description:
                            `O contrato foi ${obj.status ? 'ativado' : 'inativado'} com sucesso!`,
                    });
                } catch (error) {
                    setLoadingTable(false);
                    notification.error({
                        message: 'Erro',
                        description:
                            `Não foi possivel
                        ${obj.status ? 'ativar' : 'inativar'}
                         o contrato, entre em contato com suporte!`
                    });
                }
                setHasSelectedAdd(true);
                setHasSelectedEdit(false);
                setHasSelectedDel(false);
                setHasSelectedView(false);
                setSelectedRowKeys([]);

            }
        }

        buscaDeDados();
    }, [selectedRowKeys, dadosTabelaState, buscaDadosContratosAtivosAndSetTable, buscaDadosContratosInativosAndSetTable]);

    const onClickInativarContrato = useCallback((): void => {
        Modal.confirm({
            className: 'modalContratoAtivoInativo',
            title: 'Cuidado',
            icon: <ExclamationCircleOutlined />,
            content: 'Os usuários deste contrato perderão todo o acesso ao sistema! Tem certeza que deseja continuar?',
            okText: 'Sim',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk() {
                requestAtivarOuInativarContrato({ status: false });
            },
            onCancel() {
            },
        });
    }, [requestAtivarOuInativarContrato]);

    const onClickAtivarContrato = useCallback((): void => {
        Modal.confirm({
            className: 'modalContratoAtivoInativo',
            title: 'Cuidado',
            icon: <ExclamationCircleOutlined />,
            content: 'Os usuários deste contrato terão acesso novamente ao sistema! Tem certeza que deseja continuar?',
            okText: 'Sim',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk() {
                requestAtivarOuInativarContrato({ status: true });
            },
            onCancel() {
            },
        });
    }, [requestAtivarOuInativarContrato]);


    const clickBotaoDeletarDados = useCallback((): void => {
        const requestAsync = () => {

            if (selectedRowKeys.length == 1) {
                let linha: any = [];
                dadosTabelaState.forEach(({ nome, uuid, id }): void => {

                    selectedRowKeys.forEach((val, i) => {
                        if (uuid == val) {
                            linha.push({ id })
                        }
                    });

                })

                const excluirDadosModal = async () => {
                    try {
                        setLoadingTable(true)

                        await axios.delete(urlContrato + '/' + linha[0].id, {
                            headers: { 'Authorization': 'Bearer ' + getToken() }
                        })

                        notification.success({
                            message: 'Sucesso',
                            description:
                                'Contrato deletado com sucesso.',
                        });
                        onChangeSelectFiltroBuscaTabela(refValorSelecioneFiltro.current)

                        setLoadingTable(false)

                        setHasSelectedAdd(true);
                        setHasSelectedEdit(false);
                        setSelectedRowKeys([]);
                    } catch (error: any) {
                        setLoadingTable(false)
                        notification.error({
                            message: 'Erro',
                            description:
                                error?.response?.data?.message ? error?.response?.data?.message : 'Não foi possível deletar, entre em contato com suporte!',
                        });
                    }
                }
                excluirDadosModal();

            }
        }

        Modal.confirm({
            className: 'classmodalDadosContatoInatendimento',
            title: 'Atenção',
            icon: <ExclamationCircleOutlined />,
            content: `A exclusão do contrato é irreversível e ele não poderá mais ser encontrado. Deseja realmente excluir?`
            ,
            okText: 'Sim',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk() {
                requestAsync();
            },
            onCancel() {
            },
        });

    }, [selectedRowKeys, dadosTabelaState]);

    const onClickDesvincularUser = (): void => {
        setLoadingTableModal(true);
        const buscaDeDados = async () => {

            if (selectedRowKeys.length == 1) {
                let linha: any = [];
                dadosTabelaState.forEach(({ nome, uuid, id }): void => {

                    selectedRowKeys.forEach((val, i) => {
                        if (uuid == val) {
                            linha.push({ id, nome })
                        }
                    });

                })

                try {

                    //abrir modal antes da requisição
                    setModalDesvincularUserVisible(true);

                    let resultUsuarios = await axios.get(urlContratoUsuariosVinculados + "/" + linha[0].id, {
                        headers: { 'Authorization': 'Bearer ' + getToken() }
                    });

                    let userAtivoCheck: Array<any> = [];
                    let userInativoCheck: Array<any> = [];
                    resultUsuarios.data.forEach((valorRequest: dadosUsuariosTabelaModal): void => {

                        if (valorRequest.status_vinculo) {
                            userAtivoCheck.push(valorRequest.id.toString());
                        } else {
                            userInativoCheck.push(valorRequest.id.toString());
                        }

                    });

                    //setandop check na tabela
                    setSelectedRowKeysModal(userAtivoCheck);

                    setDadosTabelaUsuariosModal({
                        id: linha[0]?.id,
                        nome: linha[0]?.nome,
                        usuarios: resultUsuarios.data,
                        qtdAtivos: userAtivoCheck.length,
                        qtdInativos: userInativoCheck.length,
                    });

                    refIdContratoSelecionado.current = linha[0].id;
                    refDadosUsuarioModal.current = resultUsuarios.data;

                    setLoadingTableModal(false);

                } catch (error) {
                    setLoadingTableModal(false);
                    notification.error({
                        message: 'Erro',
                        description: `Não foi possivel buscar, entre em contato com suporte!`
                    });
                }
            }
        }

        buscaDeDados();

    }
    // }, [selectedRowKeys, dadosTabelaState]);

    const onClickListarUsuariosDoContrato = useCallback((): void => {
        setLoadingTableModal(true);
        const buscaDeDados = async () => {

            if (selectedRowKeys.length == 1) {
                let linha: any = [];
                dadosTabelaState.forEach(({ nome, uuid, id, plano, poder }): void => {

                    selectedRowKeys.forEach((val, i) => {
                        if (uuid == val) {
                            linha.push({ id, nome, plano, poder })
                        }
                    });

                })

                try {

                    localStorage.setItem('@GovFacil:ListUsersContrato', JSON.stringify(linha[0]));

                    history.push(`/usuarios`);

                } catch (error) {
                    setLoadingTableModal(false);
                    notification.error({
                        message: 'Erro',
                        description: `Não foi possivel buscar, entre em contato com suporte!`
                    });
                }
            }
        }

        buscaDeDados();

    }, [selectedRowKeys, dadosTabelaState]);

    const onClickPgModuloDoContrato = useCallback((): void => {
        setLoadingTableModal(true);
        const buscaDeDados = async () => {

            if (selectedRowKeys.length == 1) {
                let linha: any = [];
                dadosTabelaState.forEach(({ nome, uuid, id }): void => {

                    selectedRowKeys.forEach((val, i) => {
                        if (uuid == val) {
                            linha.push({ id, nome })
                        }
                    });

                })

                try {

                    // localStorage.setItem('@GovFacil:ModuloDoContrato', JSON.stringify(linha[0]));

                    history.push(`/contrato/modulo/${linha[0].id}`);

                } catch (error) {
                    setLoadingTableModal(false);
                    notification.error({
                        message: 'Erro',
                        description: `Não foi possivel buscar, entre em contato com suporte!`
                    });
                }
            }
        }

        buscaDeDados();

    }, [selectedRowKeys, dadosTabelaState]);

    const clickVincOuDesvincularUsuarioContrato = (obj: { id: number, ativo: boolean }): void => {

        const alterarDadosUsuario = async () => {

            setLoadingTableModal(true);


            let objStatus: any = {};
            objStatus.contratoId = refIdContratoSelecionado.current
            objStatus.usuarioId = obj.id
            objStatus.ativo = obj.ativo

            try {
                await axios.patch(urlContratosUsuarioControlador, objStatus, {
                    headers: { 'Authorization': 'Bearer ' + getToken() }
                });

                notification.success({
                    message: 'Sucesso',
                    description: `Alterações feitas com sucesso!`
                });

                // setModalDesvincularUserVisible(false);
                // setLoadingTableModal(false);
                onClickDesvincularUser();
            } catch (error) {
                setLoadingTableModal(false);
                notification.error({
                    message: 'Erro',
                    description: `Não foi possivel salvar, entre em contato com suporte!`
                });
            }

        }

        alterarDadosUsuario();

    }

    const clickCancelModalAddConfig = useCallback((): void => {
        setModalDesvincularUserVisible(false);
        setSelectedRowKeysModal([]);
        setDadosTabelaUsuariosModal(undefined);
    }, []);

    // click na linha da tabela de listagem de usuario
    const onclickTable = useCallback((record: any, row: any): void => {

        if (selectedRowKeys.includes(record.uuid)) {
            let filter = selectedRowKeys.filter((val) => {
                return val != record.uuid
            })
            if (filter.length === 1) {
                setSelectedRowKeys(filter);
                setHasSelectedAdd(false);
                setHasSelectedView(true);
                setHasSelectedEdit(true);
                setHasSelectedDel(true);
            } else if (filter.length === 0) {
                setSelectedRowKeys(filter);
                setHasSelectedAdd(true);
                setHasSelectedView(false);
                setHasSelectedEdit(false);
                setHasSelectedDel(false);
            } else {
                setSelectedRowKeys(filter);
            }

        } else {
            if (selectedRowKeys.length == 0) {
                setSelectedRowKeys([record.uuid]);
                setHasSelectedAdd(false);
                setHasSelectedView(true);
                setHasSelectedEdit(true);
                setHasSelectedDel(true);
            } else {
                let teste = selectedRowKeys.concat(record.uuid);
                setSelectedRowKeys(teste);
                setHasSelectedAdd(false);
                setHasSelectedView(false);
                setHasSelectedEdit(false);
                setHasSelectedDel(true);
            }
        }
    }, [selectedRowKeys]);

    // click na linha da tabela de listagem de usuario
    const onclickTableModal = useCallback((record: any, row: any): void => {
        if (selectedRowKeysModal.includes(record.id.toString())) {
            let filter = selectedRowKeysModal.filter((val) => {
                return val != record.id.toString()
            })
            if (filter.length === 1) {
                setSelectedRowKeysModal(filter);
            } else if (filter.length === 0) {
                setSelectedRowKeysModal(filter);
            } else {
                setSelectedRowKeysModal(filter);
            }

        } else {
            if (selectedRowKeysModal.length == 0) {
                setSelectedRowKeysModal([record.id.toString()]);
            } else {
                let teste = selectedRowKeysModal.concat(record.id.toString());
                setSelectedRowKeysModal(teste);
            }
        }
    }, [selectedRowKeysModal, setSelectedRowKeysModal]);

    //checkbox da tabela de listagem
    const onSelectChangeModal = useCallback((selectedRowKeysModal): void => {
        if (selectedRowKeysModal.length > 1) {
            setSelectedRowKeysModal(selectedRowKeysModal);
        } else if (selectedRowKeysModal.length === 0) {
            setSelectedRowKeysModal(selectedRowKeysModal);
        } else {
            setSelectedRowKeysModal(selectedRowKeysModal);
        }
    }, [selectedRowKeysModal]);

    const rowSelectionModal = {
        selectedRowKeys: selectedRowKeysModal,
        onChange: onSelectChangeModal,
        columnWidth: '1%'
    };

    const columnsModal = [
        {
            title: 'Nome do Usuario',
            dataIndex: 'nome',
            ...getColumnSearchPropsModal('nome'),
            width: '15%',
        },
        {
            title: 'Celular',
            dataIndex: 'celular',
            ...getColumnSearchProps('celular'),
            width: '9%',
            render: (celular: any) => {
                let formatedCell: string | null = null
                if (celular) {

                    const originalValue = unMask(celular);
                    const maskedValue = mask(originalValue, [
                        "(99) 9999-9999",
                        "(99) 9 9999-9999"
                    ]);
                    formatedCell = maskedValue;
                }
                return formatedCell
            }
        },
        {
            title: 'Ação',
            dataIndex: 'status_vinculo',
            width: '5%',
            sorter: (a: any, b: any) => a?.status_vinculo - b?.status_vinculo,
            showSorterTooltip: false,
            render: (status_vinculo: any, record: any) =>
                status_vinculo ? (
                    <Tooltip title="Desvincular" color="red">
                        <Button
                            type="primary"
                            danger
                            onClick={() => {
                                clickVincOuDesvincularUsuarioContrato({
                                    id: record.id,
                                    ativo: false
                                })
                            }}
                        >
                            <UserDeleteOutlined size={29} />
                        </Button>
                    </Tooltip>
                ) :
                    <Tooltip title="Vincular" color="green">
                        <Button
                            type="primary"
                            color='green'
                            className='btn_success_vlhbegoawrgbvr'
                            style={{
                                margin: 0,
                                marginTop: 0
                            }}
                            onClick={() => {
                                clickVincOuDesvincularUsuarioContrato({
                                    id: record.id,
                                    ativo: true
                                })
                            }}
                        >
                            <UserAddOutlined />
                        </Button>
                    </Tooltip>
            ,
        },

    ];

    //checkbox da tabela de listagem
    const onSelectChange = useCallback((selectedRowKeys): void => {
        if (selectedRowKeys.length > 1) {
            setSelectedRowKeys(selectedRowKeys);
            setHasSelectedAdd(false);
            setHasSelectedView(false);
            setHasSelectedEdit(false);
            setHasSelectedDel(true);
        } else if (selectedRowKeys.length === 0) {
            setSelectedRowKeys(selectedRowKeys);
            setHasSelectedAdd(true);
            setHasSelectedView(false);
            setHasSelectedEdit(false);
            setHasSelectedDel(false);
        } else {
            setSelectedRowKeys(selectedRowKeys);
            setHasSelectedAdd(false);
            setHasSelectedView(true);
            setHasSelectedEdit(true);
            setHasSelectedDel(true);
        }
    }, [selectedRowKeys]);

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        columnWidth: '1%'
    };

    const columns = useMemo(() => {

        return [
            {
                title: 'Nome do contrato',
                dataIndex: 'nome',
                ...getColumnSearchProps('nome'),
                width: '15%',
                defaultFilteredValue: (filterTipo_contrato?.nome && filterTipo_contrato?.nome !== null) ? filterTipo_contrato.nome : undefined,
                sorter: (a: any, b: any) => (a.nome ?? '').localeCompare(b.nome ?? ''),
                defaultSortOrder: ((sortersTableListContrato?.field && sortersTableListContrato?.field === 'nome') && (typeof sortersTableListContrato?.order === 'string')) ?
                    sortersTableListContrato?.order : undefined,
                showSorterTooltip: false,
            },
            {
                title: 'Plano',
                dataIndex: 'plano',
                ...getColumnSearchProps2('plano'),
                width: '6%',
                defaultFilteredValue: (filterTipo_contrato?.plano && filterTipo_contrato?.plano !== null) ? filterTipo_contrato.plano : undefined,
                sorter: (a: any, b: any) => {
                    return (
                        a.plano.nome.localeCompare(b.plano.nome)
                    )
                },
                defaultSortOrder: ((sortersTableListContrato?.field && sortersTableListContrato?.field === 'plano') && (typeof sortersTableListContrato?.order === 'string')) ?
                    sortersTableListContrato?.order : undefined,
                showSorterTooltip: false,
                render: (val: any) => {
                    return (
                        val?.nome
                        // <span>
                        //     <Tag color={''} key={val?.id}>
                        //         {}
                        //     </Tag>
                        // </span>
                    )
                }
            },
            {
                title: 'Vendedor',
                dataIndex: 'vendedores',
                ...getColumnSearchProps2Arr('vendedores'),
                width: '6%',
                defaultFilteredValue: (filterTipo_contrato?.vendedores && filterTipo_contrato?.vendedores !== null) ? filterTipo_contrato.vendedores : undefined,
                sorter: (a: any, b: any) => {
                    const nomeA = a.vendedores?.[0]?.nome ?? '';
                    const nomeB = b.vendedores?.[0]?.nome ?? '';
                    return nomeA.localeCompare(nomeB);
                },
                defaultSortOrder: ((sortersTableListContrato?.field && sortersTableListContrato?.field === 'vendedores') && (typeof sortersTableListContrato?.order === 'string')) ?
                    sortersTableListContrato?.order : undefined,
                showSorterTooltip: false,
                render: (val: any) => {
                    return (
                        val[0]?.nome
                        // <span>
                        //     <Tag color={''} key={val?.id}>
                        //         {}
                        //     </Tag>
                        // </span>
                    )
                }
            },
            {
                title: 'Poder',
                dataIndex: 'poder',
                ...getColumnSearchProps2('poder'),
                width: '6%',
                defaultFilteredValue: (filterTipo_contrato?.poder && filterTipo_contrato?.poder !== null) ? filterTipo_contrato.poder : undefined,
                render: (val: any) => val?.nome,
                showSorterTooltip: false,
            },
            {
                title: 'Tipo de contrato',
                dataIndex: 'tipo_contrato',
                // ...getColumnSearchProps2('tipo_contrato'),
                filters: [
                    {
                        text: 'Período de Teste',
                        value: 'Período de Teste',
                    },
                    {
                        text: 'Govfácil',
                        value: 'Govfácil',
                    },
                    {
                        text: 'Parceiros',
                        value: 'Parceiros',
                    },
                    {
                        text: 'Cliente',
                        value: 'Cliente',
                    },
                    {
                        text: 'Automático',
                        value: 'Automático',
                    },
                ],
                defaultFilteredValue: (filterTipo_contrato?.tipo_contrato && filterTipo_contrato?.tipo_contrato !== null) ? filterTipo_contrato.tipo_contrato : undefined,
                onFilter: (value: any, record: any) => {
                    return record.tipo_contrato?.nome?.indexOf(value) === 0
                    // return true
                },
                width: '6%',
                render: (val: any) => {
                    let cor = '';
                    switch (val?.nome) {
                        case 'Cliente':
                            cor = 'green';
                            break;
                        case "Período de Teste":
                            cor = 'gold';
                            break;
                        case "Parceiros":
                            cor = 'red';
                            break;
                        case "Govfácil":
                            cor = 'blue';
                            break;

                        default:
                            cor = ''
                            break;
                    }
                    return (
                        <span>
                            <Tag color={cor} key={val?.id}>
                                {val?.nome}
                            </Tag>
                        </span>
                    )
                },

            },
            // {
            //     title: 'Situação',
            //     dataIndex: 'situacao_contrato',
            //     // ...getColumnSearchProps2('situacao_contrato'),
            //     width: '8%',
            //     filters: [
            //         {
            //             text: 'Aguardando Emissão NF',
            //             value: 'Aguardando Emissão NF',
            //         },
            //         {
            //             text: 'Aguardando Pagamento',
            //             value: 'Aguardando Pagamento',
            //         },
            //         {
            //             text: 'Pago',
            //             value: 'Pago',
            //         },
            //         {
            //             text: 'Encerrado',
            //             value: 'Encerrado',
            //         },
            //         {
            //             text: 'Cancelado',
            //             value: 'Cancelado',
            //         },
            //         {
            //             text: 'Proposta Enviada',
            //             value: 'Proposta Enviada',
            //         },
            //         {
            //             text: 'Período de Teste',
            //             value: 'Período de Teste',
            //         },
            //         {
            //             text: 'Processo em Andamento',
            //             value: 'Processo em Andamento',
            //         },
            //     ],
            //     onFilter: (value: any, record: any) => {
            //         return record.situacao_contrato?.nome?.indexOf(value) === 0
            //     },
            //     render: (val: any) => {
            //         let cor = '';
            //         switch (val?.nome) {
            //             case 'Pago':
            //                 cor = 'green';
            //                 break;
            //             case "Proposta Enviada":
            //                 cor = 'gold';
            //                 break;
            //             case "Aguardando Emissão NF":
            //                 cor = 'blue';
            //                 break;
            //             case "Aguardando Pagamento":
            //                 cor = 'purple';
            //                 break;
            //             case "Cancelado":
            //                 cor = 'red';
            //                 break;
            //             case "Encerrado":
            //                 cor = 'red';
            //                 break;
            //             case "Período de Teste":
            //                 cor = 'volcano';
            //                 break;

            //             default:
            //                 cor = ''
            //                 break;
            //         }
            //         return (
            //             <span>
            //                 <Tag color={cor} key={val?.id}>
            //                     {val?.nome}
            //                 </Tag>
            //             </span>
            //         )
            //     },
            // },
            {
                title: 'Validade de Teste',
                dataIndex: 'validade_teste',
                ...getColumnSearchPropsData('validade_teste'),
                width: '5%',
                defaultFilteredValue: (filterTipo_contrato?.validade_teste && filterTipo_contrato?.validade_teste !== null) ? filterTipo_contrato.validade_teste : undefined,
                showSorterTooltip: false,
                sorter: (a: any, b: any): any => {

                    let aMonMen: number = 0
                    let bMonMen: number = 0
                    if (a?.validade_teste) {
                        aMonMen = moment(a.validade_teste).unix()
                    } else {
                        aMonMen = 0
                    }
                    if (b?.validade_teste) {
                        bMonMen = moment(b.validade_teste).unix()
                    } else {
                        bMonMen = 0
                    }

                    return aMonMen - bMonMen
                },
                defaultSortOrder: ((sortersTableListContrato?.field && sortersTableListContrato?.field === 'validade_teste') && (typeof sortersTableListContrato?.order === 'string')) ?
                    sortersTableListContrato?.order : undefined,
                render: (validade_teste: any): any => {
                    let data: any = null;
                    if (validade_teste) {
                        data = moment(validade_teste).format('DD/MM/YYYY')
                    }
                    return (
                        data
                    )
                },
            },
            {
                title: 'Vigencia Atual',
                dataIndex: 'vigencia_atual',
                ...getColumnSearchPropsData('vigencia_atual'),
                width: '5%',
                defaultFilteredValue: (filterTipo_contrato?.vigencia_atual && filterTipo_contrato?.vigencia_atual !== null) ? filterTipo_contrato.vigencia_atual : undefined,
                showSorterTooltip: false,
                defaultSortOrder: ((sortersTableListContrato?.field && sortersTableListContrato?.field === 'vigencia_atual') && (typeof sortersTableListContrato?.order === 'string')) ?
                    sortersTableListContrato?.order : undefined,
                sorter: (a: any, b: any): any => {

                    let aMonMen: number = 0
                    let bMonMen: number = 0
                    if (a?.vigencia_atual) {
                        aMonMen = moment(a.vigencia_atual).unix()
                    } else {
                        aMonMen = 0
                    }
                    if (b?.vigencia_atual) {
                        bMonMen = moment(b.vigencia_atual).unix()
                    } else {
                        bMonMen = 0
                    }

                    return aMonMen - bMonMen
                },
                render: (vigencia_atual: any): any => {
                    let data: any = null;
                    if (vigencia_atual) {
                        data = moment(vigencia_atual).format('DD/MM/YYYY')
                    }
                    return (
                        data
                    )
                },
            },
            // {
            //     title: 'Criado',
            //     dataIndex: 'created_at',
            //     ...getColumnSearchPropsData('created_at'),
            //     width: '2%',
            //     sorter: (a: any, b: any) => {

            //         let aMonMen: any = null
            //         let bMonMen: any = null
            //         if (a.created_at) {
            //             aMonMen = moment(a.created_at).unix()
            //         } else {
            //             aMonMen = 0
            //         }
            //         if (b.created_at) {
            //             bMonMen = moment(b.created_at).unix()
            //         } else {
            //             bMonMen = 0
            //         }

            //         return aMonMen - bMonMen
            //     },
            //     showSorterTooltip: false,
            //     // sorter: (a: any, b: any) => a.created_at.localeCompare(b.created_at),
            //     render: (criado: any) => (
            //         moment(criado).format('DD/MM/YYYY HH:mm')
            //     ),
            // }
        ];
    }, [filterTipo_contrato])

    return (
        <>
            <Spin spinning={loadingPage}>
                <div
                    className="header-print-hide"
                    style={{
                        position: 'fixed',
                        zIndex: 2,
                        // paddingTop: 24,
                        // paddingBottom: 10,
                        // paddingLeft: 24,
                        // paddingRight: 10,
                        // margin: -24,
                    }}
                >
                    <Row style={{ marginBottom: 16 }}>
                        <Col>
                            <Button
                                type="primary"
                                style={{ marginRight: 5, marginBottom: 5 }}
                                className="btn_success_vlhbegoawrgbvr"
                                disabled={!hasSelectedAdd}
                                onClick={clickBotaoAddContrato}
                            >
                                Adicionar
                            </Button>
                        </Col>
                        <Col>
                            <Button
                                type="primary"
                                style={{ marginRight: 5, marginBottom: 5 }}
                                className="btn_warning_cewuyfgfvewofc"
                                onClick={clickBotaoEditarContrato}
                                disabled={!hasSelectedEdit}
                            >
                                Editar
                            </Button>
                        </Col>
                        <Col>
                            <Select
                                showSearch
                                placeholder="Selecione..."
                                style={{ marginRight: 5, marginBottom: 5 }}
                                optionFilterProp="children"
                                // className="botaoListSelectContrato"
                                onChange={onChangeSelectFiltroBuscaTabela}
                                disabled={!hasSelectedAdd}
                                defaultValue='Contratos'
                                filterOption={(input: any, option: any) =>
                                    option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                <Select.Option value="Contratos">Ativos</Select.Option>
                                <Select.Option value="Inativos">Inativos</Select.Option>
                            </Select>
                        </Col>
                        <Col>


                            {valorSelecione == 'Inativos' ?
                                <Button
                                    className="btn_success_vlhbegoawrgbvr"
                                    style={{ marginRight: 5, marginBottom: 5 }}
                                    type="primary"
                                    onClick={onClickAtivarContrato}
                                    // disabled={!hasSelectedDel}
                                    disabled={!hasSelectedEdit}
                                >
                                    Ativar
                                </Button>
                                : ""}
                        </Col>
                        <Col>
                            {valorSelecione != 'Inativos' ?
                                <Button
                                    style={{ marginRight: 5, marginBottom: 5 }}
                                    type="primary"
                                    danger
                                    onClick={onClickInativarContrato}
                                    disabled={!hasSelectedEdit}
                                >
                                    Inativar
                                </Button>
                                :
                                ""
                            }
                        </Col>
                        {/* <Col>

                        <Popconfirm
                            title="Deseja excluir?"
                            onConfirm={clickBotaoDeletarDados}
                            onCancel={() => { }}
                            okText="Sim"
                            cancelText="Não"
                        >
                            <Button
                                // className="botaoDeleteAssociacao"
                                type="primary"
                                danger
                                disabled={!hasSelectedEdit}
                                style={{ marginRight: 5, marginBottom: 5 }}
                            >
                                <DeleteOutlined />
                            </Button>
                        </Popconfirm>
                    </Col> */}
                        <Col>
                            {!hasSelectedEdit ?
                                <Button
                                    type="primary"
                                    onClick={onClickDesvincularUser}
                                    style={{ marginRight: 5, marginBottom: 5 }}
                                    key='fixoDesvincularsuario'
                                    disabled={!hasSelectedEdit}
                                >
                                    <IconDesvincularUser style={{ fontSize: 20 }} />
                                </Button>
                                :
                                <Tooltip title="Desvincular Usuários" color="blue" key="bluedesvincular">
                                    <Button
                                        type="primary"
                                        key='tootiplDesvincularsuario'
                                        onClick={onClickDesvincularUser}
                                        style={{ marginRight: 5, marginBottom: 5 }}
                                        disabled={!hasSelectedEdit}
                                    >
                                        <IconDesvincularUser style={{ fontSize: 20 }} />
                                    </Button>
                                </Tooltip>
                            }
                        </Col>
                        <Col>
                            {!hasSelectedEdit ?
                                <Button
                                    type="primary"
                                    style={{ marginRight: 5, marginBottom: 5 }}
                                    disabled={!hasSelectedEdit}
                                    key='fixoListarUsuario'
                                >
                                    <IconUsuarios style={{ fontSize: 20 }} />
                                </Button>
                                :
                                <Tooltip title="Listar Usuários" color="blue" key="blueListarUsuarios">
                                    <Button
                                        type="primary"
                                        style={{ marginRight: 5, marginBottom: 5 }}
                                        key='tooltipListarUsuario'
                                        onClick={onClickListarUsuariosDoContrato}
                                        disabled={!hasSelectedEdit}
                                    >
                                        <IconUsuarios style={{ fontSize: 22 }} />
                                    </Button>
                                </Tooltip>
                            }
                        </Col>
                        <Col>
                            {!hasSelectedEdit ?
                                <Button
                                    type="primary"
                                    style={{ marginRight: 5, marginBottom: 5 }}
                                    className="btn_success_vlhbegoawrgbvr"
                                    key='fixoCadastrarModulo'
                                    // onClick={onClickDesvincularUser}
                                    disabled={!hasSelectedEdit}
                                >
                                    Entidade
                                    {/* <IconBiLayerPlus style={{ fontSize: 20 }} /> */}
                                </Button>
                                :
                                <Button
                                    type="primary"
                                    style={{ marginRight: 5, marginBottom: 5 }}
                                    key='TolltipCadastrarModulo'
                                    onClick={onClickPgModuloDoContrato}
                                    disabled={!hasSelectedEdit}
                                    className="btn_success_vlhbegoawrgbvr"
                                >
                                    Entidade
                                </Button>
                            }
                        </Col>
                        <Col>
                            {dadosTabelaState.length > 0 && (
                                <Button
                                    type="primary"
                                    danger
                                    onClick={handleClickPrint}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginRight: 5,
                                        marginBottom: 5,
                                    }}
                                >
                                    {'Imprimir PDF '}
                                    <FilePdfOutlined style={{ fontSize: 22 }} />
                                </Button>
                            )}
                        </Col>
                    </Row>
                </div>
                <div className='headerAbaixodosBtnTableList_ihabdfvohewvbfopu' />
                <Table
                    // style={{
                    //     marginTop: 50
                    // }}
                    // className='marginTopTables'
                    rowKey={(record) => record.uuid}
                    loading={loadingTable}
                    onRow={(record, rowIndex) => {
                        return {
                            onClick: event => { onclickTable(record, rowIndex) }, // click row
                        };
                    }}
                    rowSelection={rowSelection}
                    columns={columns} dataSource={dadosTabelaState}
                    scroll={{ x: 1100 }}
                    size="small"
                    onChange={
                        (pagination, filters, sorter, extra) => {
                            refContagemDoFiltro.current = extra.currentDataSource;
                            setDadosFiltradosParaImpressao(extra.currentDataSource);

                            if (extra.action === 'filter') {
                                localStorage.setItem(NAME_LS_STORAGE_FILTERS, JSON.stringify(filters));
                            }

                            if (extra.action === 'sort') {
                                localStorage.setItem(NAME_LS_STORAGE_SORTERS, JSON.stringify(sorter));
                            }

                        }
                    }
                    title={(registros) => {
                        return (
                            <div
                                style={{
                                    backgroundColor: propsState.theme === 'light' ? '#FAFAFA' : '#1D1D1D',
                                    padding: 10,
                                    margin: -8,
                                    marginBottom: 0.5
                                }}
                            >
                                <Text>
                                    {/* {`Total: ${dadosTabelaState.length} registros.`} */}
                                    {`Mostrando: ${registros.length} de ${refContagemDoFiltro.current.length === 0 ?
                                        dadosTabelaState.length :
                                        refContagemDoFiltro.current.length} num total de ${dadosTabelaState.length} `}
                                </Text>
                            </div>
                        )
                    }}
                    footer={(registros) => {
                        return (
                            <div
                                style={{
                                    textAlign: 'end'
                                }}
                            >
                                <Text>
                                    {/* {`Total: ${dadosTabelaState.length} registros.`} */}
                                    {`Mostrando: ${registros.length} de ${refContagemDoFiltro.current.length === 0 ?
                                        dadosTabelaState.length :
                                        refContagemDoFiltro.current.length} num total de ${dadosTabelaState.length} `}
                                </Text>
                            </div>
                        )
                    }}
                    pagination={{
                        locale: { items_per_page: '' },
                        showSizeChanger: true,
                        defaultPageSize: 100,
                        position: ['topRight', 'bottomRight'],
                        pageSizeOptions: ['10', '20', '50', '100']
                    }}
                    locale={locale.Table}
                />
                {showPrintComponent && (
                    <div style={{ display: 'none' }}>
                        <TableWrapperPrint
                            ref={refComponentToPrint}
                            columns={columns}
                            dataSource={dadosFiltradosParaImpressao.length > 0 ? dadosFiltradosParaImpressao : dadosTabelaState}
                            loading={loadingTable}
                            refContagemDoFiltro={refContagemDoFiltro}
                            propsState={propsState}
                        />
                    </div>
                )}
            </Spin>
            <Modal
                title="Desvincular Usuários"
                open={modalDesvincularUserVisible}
                destroyOnClose
                width={600}
                onOk={clickCancelModalAddConfig}
                onCancel={clickCancelModalAddConfig}
                footer={[
                    <Button key="back" disabled={loadingTableModal}
                        onClick={clickCancelModalAddConfig}>
                        Cancelar
                    </Button>,
                    <Button key="submit" type="primary" loading={loadingTableModal}
                        onClick={clickCancelModalAddConfig}>
                        OK
                    </Button>,
                ]}
            >
                {
                    dadosTabelaUsuariosModal && (
                        <div
                            style={{
                                marginBottom: 15
                            }}
                        >
                            <Text style={{
                                margin: 5,
                                fontSize: 18,
                            }}>
                                {`Contrato: ${dadosTabelaUsuariosModal?.nome}`}
                            </Text>
                        </div>
                    )
                }

                <Table
                    rowKey={(record) => record.id.toString()}
                    loading={loadingTableModal}
                    rowClassName={(record, index) => (record.status_vinculo ? "ativoList" : "inativoList")}
                    // onRow={(record, rowIndex) => {
                    //     return {
                    //         onClick: event => { onclickTableModal(record, rowIndex) }, // click row
                    //     };
                    // }}
                    // rowSelection={rowSelectionModal}
                    columns={columnsModal} dataSource={dadosTabelaUsuariosModal?.usuarios || []}
                    scroll={{ y: 200 }}
                    onChange={
                        (pagination, filters, sorter, extra) => {
                            refContagemDoFiltroTabelaModal.current = extra.currentDataSource
                        }
                    }
                    title={(registrosTabela) => {

                        return (
                            <div
                                style={{
                                    backgroundColor: propsState.theme === 'light' ? '#FAFAFA' : '#1D1D1D',
                                    padding: 10,
                                    margin: -8,
                                    marginBottom: 0.5
                                }}
                            >
                                <Text>
                                    {/* {`Total: ${dadosTabelaState.length} registros.`} */}
                                    {`Mostrando: ${registrosTabela.length} de ${refContagemDoFiltroTabelaModal.current.length === 0 ?
                                        dadosTabelaUsuariosModal?.usuarios?.length :
                                        refContagemDoFiltroTabelaModal.current.length} num total de ${dadosTabelaUsuariosModal?.usuarios?.length} `}
                                </Text>
                            </div>
                        )
                    }}
                    size="small"
                    pagination={{ locale: { items_per_page: '' } }}
                    locale={locale.Table}
                />
            </Modal>
        </>
    );
}

export default ListagemContrato;
